module["exports"] = [
  "Indonesia"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/default_country.js
// module id = 1255
// module chunks = 0